import React, { useState } from 'react';
import Vimeo from '@u-wave/react-vimeo';
import './Video.css';

let ready = false;
let youtubeElement = null;

const Video = props => {
  const [playing, setPlaying] = useState(false);
  const {
    deviceWidth,
    locale,
    content: { videoId, coverImg, playImg, videoLink }
  } = props;

  const assets = process.env.PUBLIC_URL + '/Assets/';

  const play = () => {
    if (ready) {
      setPlaying(true);
      youtubeElement.play();
    } else {
      setTimeout(play, 100);
    }
  };

  const clickPlay = () => {
    var playBtn = document.querySelector('.video__overlay');
    var staicVideo = document.querySelector('.video__static');
    playBtn.style.display = 'none';
    staicVideo.play();
  };

  const onReadyYT = event => {
    ready = true;
    youtubeElement = event;
  };

  return (
    <section className={`section section--video ${deviceWidth >= 992 ? 'section--grey' : ''}`}>
      <div className="section__wrapper">
        <div className="video__cont">
          <div className={!playing ? 'video__overlay' : 'hidden'}>
            {locale === 'de_DE' || locale === 'en_DE' ? (
              <img
                alt="play btn"
                onClick={clickPlay}
                className={'video__play'}
                src={`${assets}${playImg}`}
              />
            ) : (
              <img
                alt="play btn"
                onClick={play}
                className={'video__play'}
                src={`${assets}${playImg}`}
              />
            )}
            <img alt="video cover" className="video__cover" src={`${assets}${coverImg}`} />
          </div>
          <div className="video__video">
            {locale === 'de_DE' || locale === 'en_DE' ? (
              <video
                src={videoLink}
                controls
                playsInline
                class="video__frame-parent video__frame-resize video__static"
              ></video>
            ) : (
              <Vimeo
                video={videoId}
                showByline={false}
                showPortrait={false}
                showTitle={false}
                className="video__frame-parent"
                onReady={event => onReadyYT(event)}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Video;
